import { RequestRoles, requestRoles } from '../../constants/requestRoles';
import { RequestTypes, requestTypes } from '../../constants/requestTypes';

const ruleRequestEntityFields: Record<RequestTypes, RequestRoles[]> = {
  [requestTypes.TRANSACTION]: [
    requestRoles.INITIATOR,
    requestRoles.RECIPIENT,
    requestRoles.PROCESSOR,
    requestRoles.SUB_PROCESSOR,
  ],
  [requestTypes.CAR_PURCHASE]: [
    requestRoles.SELLER,
    requestRoles.BUYER,
  ],
  [requestTypes.CAR_KYC]: [requestRoles.ENTITY],
  [requestTypes.INDIVIDUAL_KYC]: [requestRoles.ENTITY],
  [requestTypes.BUSINESS_KYC]: [requestRoles.ENTITY],
  [requestTypes.KYC]: [requestRoles.ENTITY],
};

export default ruleRequestEntityFields;
